import { useState } from "react";
import { dspApi } from "../repositories/dsp";
import { DSPData } from "../components/types/types";
import Swal from "sweetalert2";

export const useDspArtists = () => {
  const [dspList, setDspList] = useState<DSPData[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchDSPs = async () => {
    setLoading(true);
    try {
      const response = await dspApi.getDSPs();
      setDspList(response.data.data);
    } catch (error: any) {
      if (error.response?.status === 404) {
        setDspList([]);
      } else {
        Swal.fire(
          "Error",
          error?.response?.data?.message ||
          error.message ||
          "An unknown error occurred",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    dspList,
    loading,
    fetchDSPs,
    setDspList
  };
};
